<template>
	<div class="upload">
		<div class="files">
			<div class="file" v-for="(file, index) in files" :key="file.name">
				{{file.name}}
				<a class="icon" v-html="require('@/assets/icons/close.svg')" @click="remove({index})"/>
			</div>
		</div>
		<input type="file" ref="input" @change="update" :accept="extensions.join(',')" multiple/>
		<btn @click="upload">Upload</btn>
	</div>
</template>

<script>
import {uniqBy, takeRight} from "lodash";
import btn from "@/components/button.vue";

export default {
	components: {btn},
	props: {
		extensions: {type: Array, default: () => []},
		max: {type: Number, default: 100}
	},
	data() {
		return {
			files: []
		}
	},
	methods: {
		upload() {
			this.$refs.input.click();
		},
		update({target: {files}}) {
			this.files = takeRight(uniqBy([...this.files, ...files], "name"), this.max);
			this.$emit("update", this.files);
		},
		remove({index}) {
			this.files.splice(index, 1);
		}
	}
};
</script>

<style lang="scss" scoped>
.upload {
	.files {
		margin-bottom: 1.5em;

		.file {
			font-size: 14px;
			font-weight: 400;
			color: #7c7c7c;
			margin-bottom: 0.5em;

			display: flex;
			align-items: center;

			.icon {
				display: inline-flex;
				margin-left: 0.5em;
				margin-bottom: 2px;

				/deep/ svg {
					opacity: 0.6;
					$s: 10px;
					width: $s;
					height: $s;

					path {
						fill: #7c7c7c;
					}
				}
			}
		}
	}

	input {
		display: none;
	}

	.button {
		background-color: #E2E2E2;
		border-color: #979797;
		color: #182E38;
		text-transform: uppercase;
		padding: 1.25em 1.5em;

		@include res(tablet) {
			width: 100%;
		}
	}
}
</style>
